import { render, staticRenderFns } from "./ContactCardPreview.vue?vue&type=template&id=1eaa9e3a&scoped=true&"
import script from "./ContactCardPreview.vue?vue&type=script&lang=js&"
export * from "./ContactCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContactCardPreview.vue?vue&type=style&index=0&id=1eaa9e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaa9e3a",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
